import XButton from '../common/XButton';
import { optionCardClasses } from './preliminaryLifecareClasses';

const titleWrapClasses = 'min-h-[3.5rem] flex items-center justify-center';

const titleClasses = 'text-xl font-bold text-content m-0';

const subtitleBlockClasses = 'mt-1 mb-6';

const subtitleLineClasses = 'text-base text-subtle m-0 whitespace-nowrap';

const mediaWrapClasses = 'flex flex-col items-center text-center gap-3';

const iconWrapClasses = 'flex items-center justify-center h-28 w-28 rounded-full bg-surface-alt text-primary text-3xl';

const leadClasses = 'text-lg font-bold text-content m-0';

const descriptionClasses = 'text-base leading-relaxed text-content m-0 max-w-prose';

const actionsClasses = 'mt-auto pt-6 w-full flex justify-center';

const CertifiedSupportOptionCard = ({ isRequesting, onRequestSupport }) => (
    <div className={optionCardClasses}>
        <div className={titleWrapClasses}>
            <h3 className={titleClasses}>Request a Certified Life Care Plan</h3>
        </div>
        <div className={subtitleBlockClasses}>
            <p className={subtitleLineClasses}>Via our support team</p>
        </div>
        <div className={mediaWrapClasses}>
            <span className={iconWrapClasses}>
                <i className="fas fa-headset" />
            </span>
            <h4 className={leadClasses}>Our support team</h4>
            <p className={descriptionClasses}>
                Prefer to talk it through? Request a certified life care plan and our support team will reach out to you.
            </p>
        </div>
        <div className={actionsClasses}>
            <XButton variant="outlinePrimary" onClick={onRequestSupport} loading={isRequesting} loadingText="Sending...">
                Request Certified Life Care Plan
            </XButton>
        </div>
    </div>
);

export default CertifiedSupportOptionCard;
